import React from 'react';
import Paper from '@mui/material/Paper';
import CentsLoader from 'components/common/centsLoader/CentsLoader';
import { usePaymentDiscrepancyLogStats } from 'api/queries/usePaymentDiscrepancyLogStats';
import styles from './PaymentDiscrepancyStats.module.scss';

const StatCard = ({ label, value }: { label: string; value: number }) => (
  <div className={styles.cardItem}>
    <Paper className={styles.card}>
      <h4>{label}</h4>
      <p className={styles.value}>{value}</p>
    </Paper>
  </div>
);

export const PaymentDiscrepancyStats = () => {
  const { data, isLoading } = usePaymentDiscrepancyLogStats();

  if (isLoading) {
    return (
      <div className={styles.loadingContainer}>
        <CentsLoader />
      </div>
    );
  }

  if (!data) return null;

  return (
    <div className={styles.cardRow}>
      <StatCard label="Currently Open" value={data.openCount} />
      <StatCard label="Last Week" value={data.week.previous} />
      <StatCard label="This Week" value={data.week.current} />
      <StatCard label="Last Month" value={data.month.previous} />
      <StatCard label="This Month" value={data.month.current} />
    </div>
  );
};
